import { createAction } from 'redux-actions';
import * as actionType from './actionTypes';

const addMmrValue = createAction(actionType.ADD_MMR_VALUE);
const removeMmrValue = createAction(
  actionType.REMOVE_MMR_VALUE
);
export { addMmrValue, removeMmrValue };
